var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 0C9.3 0 9.4 0.1 9.5 0.1C10.5 0.4 11 1.2 11 2.2C11 6.1 11 10 11 13.9C11 15.2 11 16.5 11 17.8C11 19.1 10.1 19.9 8.8 19.9C7.3 19.9 5.7 19.9 4.2 19.9C3.5 19.9 2.9 19.9 2.2 19.9C0.9 20 0 19.1 0 17.8C0 16.9 0 16.1 0 15.2C0 10.9 0 6.5 0 2.2C0 1.4 0.3 0.8 0.9 0.4C1.2 0.2 1.5 0.1 1.8 0C4.3 0 6.7 0 9.2 0ZM10 3C7 3 4.1 3 1.1 3C1.1 7.6 1.1 12.3 1.1 16.9C4.1 16.9 7 16.9 10 16.9C10 12.2 10 7.6 10 3ZM5.4 19.4C5.9 19.4 6.3 19 6.3 18.5C6.3 18 5.9 17.6 5.4 17.6C4.9 17.6 4.5 18 4.5 18.5C4.5 18.9 4.9 19.4 5.4 19.4ZM5.5 1.9C5.8 1.9 6.1 1.9 6.5 1.9C6.7 1.9 6.8 1.8 6.8 1.6C6.8 1.4 6.7 1.3 6.5 1.3C5.9 1.3 5.2 1.3 4.6 1.3C4.4 1.3 4.3 1.4 4.3 1.6C4.3 1.8 4.4 1.9 4.7 1.9C4.9 1.9 5.2 1.9 5.5 1.9ZM3.6 1.9C3.8 1.9 3.9 1.8 3.9 1.6C3.9 1.4 3.8 1.3 3.6 1.3C3.4 1.3 3.3 1.4 3.3 1.6C3.3 1.7 3.4 1.9 3.6 1.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileImg);
export default __webpack_public_path__ + "static/media/mobile-img.4e352e52e7c2483cce84ba6386cf8927.svg";
export { ForwardRef as ReactComponent };